var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pricing" }, [
    _vm.yearly
      ? _c("div", { staticClass: "annual" }, [
          _c("div", [
            _vm.comboDiscount
              ? _c("div", { staticClass: "combo" }, [
                  _vm._v(
                    "SAVE $" + _vm._s(Number(_vm.comboDiscount).toFixed(2))
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(
            "\n        $" +
              _vm._s(Number(_vm.yearly).toFixed(2)) +
              "/year billed annually\n    "
          ),
        ])
      : _vm.oneTime
      ? _c("div", { staticClass: "annual" }, [
          _vm._v(
            "\n        $" + _vm._s(_vm.oneTime) + " one time payment\n    "
          ),
        ])
      : _c("div", { staticClass: "annual" }, [
          _vm._v("\n        Contact Us: 1-877-714-5001\n    "),
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "explanation" }, [_vm._v("Ends up costing:")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "price" },
      [
        _vm.monthly
          ? [
              _c("div", { staticClass: "dollars" }, [
                _vm._v("$" + _vm._s(_vm.monthly)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "per" }, [_vm._v("per month")]),
            ]
          : _vm.oneTime
          ? [
              _vm.oneTime
                ? _c("div", { staticClass: "dollars" }, [
                    _vm._v("$" + _vm._s(_vm.oneTime)),
                  ])
                : _vm._e(),
            ]
          : [
              _c("div", { staticClass: "dollars missing" }, [_vm._v("-")]),
              _vm._v(" "),
              _c("div", { staticClass: "per" }, [_vm._v("per month")]),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }